import {
	SET_COMPARE_CONTRACTS_CONTRATOS,
	SET_COMPARE_CONTRACTS_FIRE_GET_DATA,
	SET_COMPARE_CONTRACTS_FIRE_EXECUTE_USEEFFECT_AGRUPATION_SERIE_COMPONENT,
	SET_COMPARE_CONTRACTS_PILAR,
	SET_COMPARE_CONTRACTS_OPF_DATA,
	SET_COMPARE_CONTRACTS_CHART_DATA,
	SET_COMPARE_CONTRACTS_CONTRACT_FILTERS,
	SET_COMPARE_CONTRACTS_CONTRACT_FILTERS_BASE,
	SET_COMPARE_CONTRACTS_CONTRACT_FILTERS_SELECTED,
	SET_COMPARE_CONTRACTS_FILTERED_CONTRACTS,
	SET_COMPARE_CONTRACTS_BASE,
	SET_COMPARE_CONTRACTS_CONTRACT_FILTERS_SELECTED_ALL,
	SET_COMPARE_CONTRACTS_CONTRACT_FILTERS_CONFIG,
	SET_COMPARE_CONTRACTS_CONTRACT_CHARTDATA_STRUCTURE,
	SET_COMPARE_CONTRACTS_CONTRACT_SEGMENT_LIST,
	SET_COMPARE_CONTRACTS_SEGMENT_SELECTED,
	SET_COMPARE_CONTRACTS_CHART_DATA_BASE,
	SET_COMPARE_CONTRACTS_CHART_MAXIMIZED,
	SET_COMPARE_CONTRACTS_PANEL_SEGMENT_VALUES_SELECTED,
	SET_COMPARE_CONTRACTS_CONTRACT_SEGMENT_SCOPE
} from "./actions/KPI/compareContractsActions";

const initialState = {
	_pilarSeleccionado: null,
	_contratosParaGrafico: [],
	_contratosBase: [],
	_contratosFiltrados: null,
	_fireLoading: false,
	_fireUseEffectAgrupationSerieComponent: false,
	_opfData: null,
	_chartData: null,
	_chartDataBase: null,
	_chartMaximized: false,
	_panelSegmentValues: null,
	_filtrosContratos: {
		l_dinamic1: null,
		l_dinamic2: null,
	},
	_filtrosContratosBase: null,
	_filtrosContratosSeleccionados: {
		l_dinamic1: null,
		l_dinamic2: null,
	},
	_filtrosConfiguracion: null,
	_chartDataBaseStructure: null,
	_segmentList: null,
	_segmentScope: null,
	_segmentSelected: {
		titleSegment: null,
		cardSegment: null,
		propertySegment: null
	}	
};

const compareContractsReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_COMPARE_CONTRACTS_PILAR:
			return {
				...state,
				_pilarSeleccionado: action.payload,
			};

		case SET_COMPARE_CONTRACTS_CONTRATOS:
			return {
				...state,
				_contratosParaGrafico: action.payload,
			};

		case SET_COMPARE_CONTRACTS_OPF_DATA:
			return {
				...state,
				_opfData: action.payload,
			};

		case SET_COMPARE_CONTRACTS_CHART_DATA:
			return {
				...state,
				_chartData: action.payload,
			};
		case SET_COMPARE_CONTRACTS_CHART_DATA_BASE:
			return {
				...state,
				_chartDataBase: action.payload,
			};
		case SET_COMPARE_CONTRACTS_FIRE_GET_DATA:
			return {
				...state,
				_fireLoading: action.payload,
			};
		case SET_COMPARE_CONTRACTS_FIRE_EXECUTE_USEEFFECT_AGRUPATION_SERIE_COMPONENT:
			return {
				...state,
				_fireUseEffectAgrupationSerieComponent: action.payload,
			};
		case SET_COMPARE_CONTRACTS_CONTRACT_FILTERS:
			return {
				...state,
				_filtrosContratos: action.payload,
			};
		case SET_COMPARE_CONTRACTS_CONTRACT_FILTERS_BASE:
			return {
				...state,
				_filtrosContratosBase: action.payload,
			};
		case SET_COMPARE_CONTRACTS_CONTRACT_FILTERS_SELECTED:
			return {
				...state,
				_filtrosContratosSeleccionados: {
					...state._filtrosContratosSeleccionados,
					[action.payload.field]: action.payload.object
				}
			};
		case SET_COMPARE_CONTRACTS_SEGMENT_SELECTED:
			return {
				...state,
				_segmentSelected: {
					titleSegment: action.payload.titleSegment,
					cardSegment: action.payload.cardSegment,
					propertySegment: action.payload.propertySegment
				}
			};
		case SET_COMPARE_CONTRACTS_FILTERED_CONTRACTS:
			return {
				...state,
				_contratosFiltrados: action.payload,
			};
			
		case SET_COMPARE_CONTRACTS_BASE:
			return {
				...state,
				_contratosBase: action.payload,
			};	
		case SET_COMPARE_CONTRACTS_CONTRACT_FILTERS_SELECTED_ALL:
			return {
				...state,
				_filtrosContratosSeleccionados: action.payload,
			};
		case SET_COMPARE_CONTRACTS_CONTRACT_FILTERS_CONFIG:
			return {
				...state,
				_filtrosConfiguracion: action.payload,
			};
		case SET_COMPARE_CONTRACTS_CONTRACT_CHARTDATA_STRUCTURE:
			return {
				...state,
				_chartDataBaseStructure: action.payload,
			};
		case SET_COMPARE_CONTRACTS_CONTRACT_SEGMENT_LIST:
			return {
				...state,
				_segmentList: action.payload,
			};
		case SET_COMPARE_CONTRACTS_CHART_MAXIMIZED:
			return {
				...state,
				_chartMaximized: action.payload,
			};
		case SET_COMPARE_CONTRACTS_PANEL_SEGMENT_VALUES_SELECTED:
			return {
				...state,
				_panelSegmentValues: action.payload,
			};
		case SET_COMPARE_CONTRACTS_CONTRACT_SEGMENT_SCOPE:
			return {
				...state,
				_segmentScope: action.payload,
			};

		default:
			return state;
	}
};

export default compareContractsReducer;